<template>
<div id="AcademicRecordSection">
    <div class="card mb-0">
        <div class="card-body">
            <div class="d-flex align-items-center mb-4">
                <h5 class="card-title flex-grow-1 mb-0">Academic Records</h5>
                <div class="flex-shrink-0">
                    <button @click="formContext.modal = true" class="btn btn-primary" type="button">
                        Add <span class="d-none d-sm-inline">School</span>
                    </button>
                </div>
            </div>
            <CommonSpinner v-if="isLoading" />
            <div v-else class="row g-4">
                <div v-for="(data, eduIndex) in pageData.data" :key="eduIndex"
                     class="col-xxl-4 col-sm-6">
                    <academic-record-card :item="data">
                        <template v-slot:actions>
                            <div class="dropdown dropend no-arrow">
                                <button class="dropdown-toggle btn btn-sm btn-primary" type="button"
                                    role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i class="ri-more-2-fill"></i>
                                </button>
                                <ul class="dropdown-menu">
                                    <li>
                                        <button @click.prevent="openEditView(data)" class="dropdown-item"
                                        type="button"> Edit </button>
                                    </li>
                                </ul>
                            </div>
                        </template>
                    </academic-record-card>
                </div>
                <p v-if="!pageData.data.length">No academic records added</p>
            </div>
        </div>
    </div>
    <b-modal size="lg" v-model="formContext.modal" hide-footer centered
        :title="formContext.editMode ? 'Update academic record' : 'Add academic record'" title-class="fs-6"
        @hide="closeEditView()">
        <academic-record-form v-if="formContext.modal" @closeMe="closeEditView()" :edit-mode="formContext.editMode"
            :edit-item="formContext.item" @addedItem="addItem($event)" @updatedItem="updateItem($event)" />
    </b-modal>
</div>
</template>

<script>
import AcademicRecordForm from '@/components/forms/AcademicRecordForm.vue';
import AcademicRecordCard from '@/components/cards/AcademicRecordCard.vue';
import { commonEditViewMixin } from '@/mixins/commonEditViewMixin';
import { commonPaginationMixin } from '@/mixins/commonPaginationMixin';

export default {
    components:{
        AcademicRecordForm,
        AcademicRecordCard,
    },
    mixins: [
        commonEditViewMixin,
        commonPaginationMixin
    ],
    data() {
        return {
            isLoading: false,
        }
    },
    methods: {
        addItem(item){
            this.pageData.data.unshift(item);
        },
        updateItem(item){
            const dataIndex = this.pageData.data.findIndex((i) => i.id == item.id)
            Object.assign(this.pageData.data[dataIndex], item)
        },
        fetchItems() {
            this.isLoading = true
            this.$http.get('/academic-records').then((response) => {
                this.isLoading = false
                if(response.data.success){
                    this.pageData = response.data.data
                    this.initializeAll();
                }
            })
        },
        initializeAll(){
        },
    },
    created(){
        this.fetchItems()
    },
}
</script>

<style></style>